import { Directive, ElementRef, afterNextRender, inject } from '@angular/core';

const FOCUSABLE = ['input', 'button', 'select', 'textarea', '[tabindex]']
  .map((selector) => `${selector}:not([disabled]):not([tabindex="-1"])`)
  .join(', ');

/**
 * Focuses the first focusable element inside its host once rendered. Meant for content rendered
 * away from the control that opened it (a dropdown body in the overlay, a panel docked after a
 * table), which Tab from that control would not reach next.
 */
@Directive({
  selector: '[appFocusFirst]'
})
export class FocusFirstDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    afterNextRender(() =>
      this.host.nativeElement.querySelector<HTMLElement>(FOCUSABLE)?.focus()
    );
  }
}
